// extracted by css-extract-rspack-plugin
export default {"video":"_2192424e"};